import React from 'react'
import ChatNow from '../chatnow'
import Slider from "react-slick";

const ContactUs = () => {
    const slider = React.useRef(null);
    var settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };
    return (
        <div className='min-h-screen relative p-4 py-12' id="contactus">
            <div className='container mx-auto '>
                <h2 className='text-[#1E1E1E] text-5xl md:text-6xl font-bold mt-5'>Contact Us</h2>
                <p className=' text-[#1E1E1E] mt-4'>Our team of experts is ready to answer your questions, give you more info and help you.</p>
                <div className='py-4 px-5 relative'>
                    <button className='md:hidden absolute z-10 left-0 md:-left-4 top-1/3' onClick={() => slider?.current?.slickPrev()} >
                        <img src='/assets/images/arrow-left.png' alt="" className='w-20 h-20' />
                    </button>
                    <div className=''>
                        <Slider {...settings} ref={slider}>
                            <div className='p-4 sm:max-w-[320px] flex flex-col justify-center gap-2'>
                                <div className='min-h-[250px]'>
                                    <img src='/assets/images/phone-call.png' alt="" className='w-[100%]' />
                                </div>
                                <div className=''>
                                    <h2 className='text-[#1E1E1E] text-2xl font-bold mt-5 mx-auto'>Phone</h2>
                                    <p className='text-[#1E1E1E]'>123-456-7890</p>
                                </div>
                            </div>
                            <div className='p-4 sm:max-w-[320px] flex flex-col justify-center gap-2'>
                                <div className='min-h-[250px]'>
                                    <img src='/assets/images/send-email.png' alt="" className='w-[100%]' />
                                </div>
                                <div className=''>
                                    <h2 className='text-[#1E1E1E] text-2xl font-bold mt-5 mx-auto'>Email</h2>
                                    <p className='text-[#1E1E1E]'>example@example</p>
                                </div>
                            </div>
                            <div className='p-4 sm:max-w-[320px] flex flex-col justify-center gap-2'>
                                <div className='min-h-[250px]'>
                                    <img src='/assets/images/address.png' alt="" className='w-[100%]' />
                                </div>
                                <div className=''>
                                    <h2 className='text-[#1E1E1E] text-2xl font-bold mt-5 mx-auto'>Address</h2>
                                    <p className='text-[#1E1E1E]'>123 Main St, City, State, Zip</p>
                                </div>
                            </div>

                        </Slider>
                    </div>
                    <button onClick={() => slider?.current?.slickNext()} className='md:hidden absolute right-0 md:-right-4 top-1/3 '>
                        <img src='/assets/images/arrow-right.png' alt="" className='w-20 h-20' />
                    </button>
                </div>
            </div>
            <div className='absolute max-sm:left-0 right-0 bottom-2 sm:right-14 p-4'>
                <ChatNow text="Chat now!"/>
            </div>
        </div>
    )
}

export default ContactUs